import { memo } from "react";
import { CellContext } from "@tanstack/react-table";
import type { ViewTableFeatures } from "@design-system/ViewTable/core/table";
import { EntityDisplay } from "@components/entity/EntityDisplay";
import { ViewTableCell } from "@design-system/ViewTable/ViewTableCell";
import { AccountingMigrationRow } from "../utils";

export const EntityCell = memo(function EntityCell({
    row,
}: CellContext<ViewTableFeatures, AccountingMigrationRow, unknown>) {
    return (
        <ViewTableCell>
            <EntityDisplay entity={row.original.entity} />
        </ViewTableCell>
    );
});
